module.exports = __webpack_public_path__ + "img/title.cefde49c.png";